import { render, staticRenderFns } from "./CardVerified.vue?vue&type=template&id=5b70d0c6&scoped=true"
import script from "./CardVerified.vue?vue&type=script&lang=js"
export * from "./CardVerified.vue?vue&type=script&lang=js"
import style0 from "./CardVerified.vue?vue&type=style&index=0&id=5b70d0c6&prod&lang=css"
import style1 from "./CardVerified.vue?vue&type=style&index=1&id=5b70d0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70d0c6",
  null
  
)

export default component.exports